// extracted by mini-css-extract-plugin
export default {"mainWrapper":"style_mainWrapper__5JEgG","textsWrapper":"style_textsWrapper__r+591","submitter":"style_submitter__pPgwe"};